import React, {Component} from "react";
import {ASSET_BASE_URL} from "../../../../configs/website";
import { Swiper, SwiperSlide } from 'swiper/react';
import {Autoplay, FreeMode} from "swiper";
import 'swiper/swiper.css';
import Ink from "react-ink";
import {Link} from "react-router-dom";
// import $ from 'jquery';
/*import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';*/

class FeaturedStores extends Component {
	static contextTypes = {
		router: () => null,
	};

	state = {};

	componentDidUpdate(prevProps, prevState, snapshot) {
		// React.initializeTouchEvents(true);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		// console.log("stores recc",this.props.stores);
	}

	render() {
		const { slides, size, secondarySlider, slide_per_view, slide_gap } = this.props;


		return (

			<React.Fragment>

				{this.props.stores ? (
					<div className={"featured-slider-wrapper dl-card"}>
						<h2 className="item-text mb-10 dl-header">Top Store Near You</h2>

						<Swiper
							modules={[Autoplay, FreeMode]}
							spaceBetween={15}
							slidesPerView={1.7}
							navigation
							freeMode={true}
							autoplay={true}
							scrollbar={{ draggable: true }}
						>

							{this.props.stores.map((store, index)=>(
								<SwiperSlide key={`store_${index}`}>
									<Link to={"/stores/" + store.stores.slug}>
										<div className={"fs-slider-item"} style={{
											background: `linear-gradient(rgb(255 255 255 / 0%) 0%, rgb(0 0 0 / 78%) 100%), url("${ASSET_BASE_URL}${store.stores.featured_image ? store.stores.featured_image : store.stores.image}")`,
											backgroundSize: "cover",
											backgroundRepeat: "no-repeat"
										}}>
											<div className={"content-wrapper"} style={{}}>
												<div className={"tag-wrapper"}>
													<span className={"tag"}>{store.stores.restaurant_coupons_count > 1 ? `${store.stores.restaurant_coupons_count} offers` : `${store.stores.restaurant_coupons_count} offer`}</span>
												</div>

												<div className={"meta-wrapper"}>
													<h2 className={"name"}>{store.stores.name}</h2>
													<span className={"subtext truncate-1"}>{store.stores.description}</span>
													<div className={"footer"}>
														<span className={"price"}>{store.stores.approx_target_time.to_time} mins</span>
														<span className={"rating"}><i className={`f7-icons`}>star_fill</i>{store.stores.avg_rating == "0" ? (`${store.stores.rating}`) : (`${store.stores.avg_rating}`)}</span>
													</div>
												</div>

											</div>
										</div>
										<Ink></Ink>
									</Link>
								</SwiperSlide>
							))}

						</Swiper>

					</div>
				) : ("loading")}

			</React.Fragment>
		);
	}
}

export default FeaturedStores;
